import type { CalendarEvent } from '@hestia/core';
import { Icon, icons } from '../ui.js';

/** A calendar event is not a task: there is nothing to tick, nothing to move and
 *  nothing to assign. It reads as a quieter card with a coloured spine, so a day
 *  shows what is *happening* alongside what needs *doing* without the two being
 *  mistaken for each other. */
export function EventRow({ event, hue }: { event: CalendarEvent; hue: string }) {
  const time = event.allDay
    ? 'All day'
    : event.endTime && event.endTime !== event.startTime
      ? `${event.startTime} – ${event.endTime}`
      : event.startTime;

  return (
    <div className="row" style={{ background: 'rgba(255,255,255,.62)', boxShadow: 'none',
                                  gap: 13, alignItems: 'stretch' }}>
      <span style={{ width: 3, borderRadius: 2, background: `var(--${hue})`, flex: 'none' }} />
      <div style={{ flexGrow: 1, minWidth: 0 }}>
        <div style={{ fontSize: 14.5, fontWeight: 600 }}>{event.title}</div>
        <div className="row-meta">
          <span className="chip"><Icon path={icons.calendar} size={13} />{time}</span>
          {event.location && (
            <>
              <span className="sep" />
              <span className="chip" style={{ color: 'var(--ink-3)', overflow: 'hidden',
                                              textOverflow: 'ellipsis', maxWidth: 220 }}>
                {event.location}
              </span>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
